module.exports={
	"Form": "ObservationApprovalStepViewManifest",
	"Scope": "ObservationApprovalStep-View",
	"Descriptors":
	{
		"ObservationApprovalStepDetails.IDObservationApprovalStep":
		{
			"Name": "ID",
			"Hash": "ObsStepView-ID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 2,
				"Section": "ObsStepIdentity",
				"Group": "ObsStepIdentity"
			}
		},
		"ObservationApprovalStepDetails.GUIDObservationApprovalStep":
		{
			"Name": "GUID",
			"Hash": "ObsStepView-GUID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "ObsStepIdentity",
				"Group": "ObsStepIdentity"
			}
		},
		"ObservationApprovalStepDetails.IDObservationApprovalState":
		{
			"Name": "State ID",
			"Hash": "ObsStepView-StateID",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.Ordinal":
		{
			"Name": "Ordinal",
			"Hash": "ObsStepView-Ordinal",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.ObservationType":
		{
			"Name": "Observation Type",
			"Hash": "ObsStepView-ObsType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.IDRole":
		{
			"Name": "Role ID",
			"Hash": "ObsStepView-IDRole",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 3,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.IncludeHigherRoles":
		{
			"Name": "Include Higher Roles",
			"Hash": "ObsStepView-HigherRoles",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.PerformLock":
		{
			"Name": "Perform Lock",
			"Hash": "ObsStepView-PerformLock",
			"DataType": "Boolean",
			"PictForm":
			{
				"InputType": "Boolean",
				"Row": "3",
				"Width": 2,
				"Section": "ObsStepConfig",
				"Group": "ObsStepConfig"
			}
		},
		"ObservationApprovalStepDetails.CreateDate":
		{
			"Name": "Created",
			"Hash": "ObsStepView-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.CreatingIDUser":
		{
			"Name": "Created By (User ID)",
			"Hash": "ObsStepView-CreatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.UpdateDate":
		{
			"Name": "Last Updated",
			"Hash": "ObsStepView-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		},
		"ObservationApprovalStepDetails.UpdatingIDUser":
		{
			"Name": "Updated By (User ID)",
			"Hash": "ObsStepView-UpdatingIDUser",
			"DataType": "Number",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 3,
				"Section": "ObsStepAudit",
				"Group": "ObsStepAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "ObsStepIdentity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "ObsStepIdentity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Step Configuration",
			"Hash": "ObsStepConfig",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Step Configuration",
					"Hash": "ObsStepConfig",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Audit Trail",
			"Hash": "ObsStepAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Audit Trail",
					"Hash": "ObsStepAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
